// extracted by mini-css-extract-plugin
export default {"InlineOmnibar":"sub-issue-omnibar-row-module__InlineOmnibar--Hw8Qb"};